import datepickerFactory from 'jquery-datepicker';

class ContactController {
    constructor() {
        datepickerFactory($);
        this.setDatePicker();
        this.setTimePicker();
        this.setSubmitOnce();
        this.setToggleNext();
        this.setToggleSubmit();
    }

    setDatePicker() {
        let yasumi = [
            // 2024-11-21 2024年12月以降の第一火曜日追加
            '250204', '250304', '250401', '250506', '250603', '250701', '250805', '250902', '251007', '251104', '251202',
            '260106', '260203', '260303', '260407', '260505', '260602', '260707', '260804', '260901', '261006', '261103', '261201',
            '270105', '270202', '270302', '270406', '270504', '270601', '270706', '270803', '270907', '271005', '271102', '271207',
            // 2025GW休み
            '250427', '250428', '250429', '250430', '250501', '250502', '250503', '250504', '250505', '250506', '250507',
        ];
        let renkyu = [];
        let options = {
            dateFormat: 'yy/mm/dd',
            nextText: '>',
            prevText: '<',
            maxDate: '+90d',
            minDate: '3d',
            beforeShowDay: function (date) {
                // console.log(date.getYear(), date.getMonth());
                //固定休
                // let yasumi = mainFunction2();
                // console.log(yasumi,formatDay(date),yasumi.indexOf(formatDay(date)));
                //水曜(3)
                if (date.getDay() == 3 || yasumi.indexOf(formatDay(date)) !== -1) {
                    return [false, "ui-state-disabled"];
                } else {
                    return [true, ""];
                }
            }
        };
        $('#js-datepicker1, #js-datepicker2, #js-datepicker3').datepicker(options);

        //保留
        function formatDay(dt) {
            var y = ('0' + (dt.getYear())).slice(-2);
            var m = ('0' + (dt.getMonth() + 1)).slice(-2);
            var d = ('0' + dt.getDate()).slice(-2);
            return (y + m + d);
        }
        function getDays(date, day) {
            const year = date.getFullYear();
            const month = date.getMonth();

            const days = [];

            for (let i = 1; i <= 31; i++) {
                const tmpDate = new Date(year, month, i);

                if (month !== tmpDate.getMonth()) break; //月代わりで処理終了
                if (tmpDate.getDay() !== day) continue; //引数に指定した曜日以外の時は何もしない
                days.push(tmpDate);
            }

            return days;
        }
        function mainFunction2() {

            const date = new Date();
            const day = 2; //（火）曜日
            const weeks = [1, 3]; //第1週目、第3週目 を指定


            const days = getDays(date, day);
            let specifiedDays = days.filter((v, i) => weeks.includes(i + 1));
            // console.log(specifiedDays);
            let d = [];
            for(let i = 0; i < specifiedDays.length; i++) {
                d.push(formatDay(specifiedDays[i]));
            }
            return d;

        }

    }

    setTimePicker() {
        $('#js-timepicker1, #js-timepicker2, #js-timepicker3').on('click', function () {
            $('.contact-content__timepicker').removeClass('is-show');
            $(this).closest('.contact-content__input').find('.contact-content__timepicker').addClass('is-show');
        });
        $('.js-timepicker-input .contact-content__timepicker-item').on('click', function () {
            let v = $(this).text();
            $(this).closest('.contact-content__input').find('.js-timepicker-target').val(v);
            $('.contact-content__timepicker').removeClass('is-show');
        });
    }

    setSubmitOnce() {
        $('form').each(function () {
            let $form = $(this);
            $form.on('submit', function () {
                let $this = $(this);
                $this.find('button').prop('disabled', true).addClass('is-send');
            });
        });
    }

    setToggleNext() {
        $('.js-toggle-next-target').slideUp(16);
        $('.js-toggle-next').each(function () {
            let $this = $(this);

            $this.find('input').each(function () {
                let $i = $(this);
                if ($i.prop('checked') === true) {
                    $this.next('.js-toggle-next-target').slideDown(100);
                } else {
                    $this.next('.js-toggle-next-target').slideUp(100);
                }
            });

            $this.find('input').on('change', function () {
                let $i = $(this);
                if ($i.prop('checked') === true) {
                    $this.next('.js-toggle-next-target').slideDown(100);
                } else {
                    $this.next('.js-toggle-next-target').slideUp(100);
                }
            });
        });
    }

    setToggleSubmit() {
        if ($('.js-toggle-submit input').prop('checked') === true) {
            $('.js-toggle-submit-target').removeClass('btn-disabled');
        } else {
            $('.js-toggle-submit-target').addClass('btn-disabled');
        }
        $('.js-toggle-submit input').on('change', function () {
            let $this = $(this);
            if ($this.prop('checked') === true) {
                $('.js-toggle-submit-target').removeClass('btn-disabled is-send');
            } else {
                $('.js-toggle-submit-target').addClass('btn-disabled');
            }
        });
    }
}
export default ContactController;
